
export function mlQuery() {
  return `{
        total
        items
        {
          title
          slug
          sys
          {
            id
          }
          __typename            
        }
      }`
};

export function getContentTypeMlQuery(contentType_ID, searchValue) {
  return `query {
  ${contentType_ID}Collection(
    where: {
      OR: [{ title_contains: "${searchValue}" }, { subTitle_contains: "${searchValue}" }]
    }
  ) {
    total
    items {
      title
      slug
      sys {
        id
      }
      __typename
    }
  }
}`;
};



export function getContentTypeKeywordQuery(contentType, subCategoryIdquery, typeOfContent, searchValue) {
  return `query {
        ${contentType}Collection(
          where: {
            AND: [
              { ${subCategoryIdquery} }, 
              { OR: [{  title_contains:"${searchValue}" }, { subTitle_contains: "${searchValue}" }] }
              { type: "${typeOfContent}" }
            ]
          }
        ) {
          total
          items {
            title
            slug
            sys {
              id
            }
            __typename
            type
          }
        }
      }`
};

export function getContentTypeKeywordIdQuery(contentType, subCategoryIdquery, typeOfContent, searchValue, limit) {
  return `query {
    ${contentType}Collection(where: {
      AND: [
       { ${subCategoryIdquery} }, 
        { OR: [{  title_contains:"${searchValue}" }, { subTitle_contains: "${searchValue}" }] }
        { type: "${typeOfContent}" }
      ],
    }${limit})
    {
      total
      items
      {         
        sys
        {
          id
        }        
      }
    }
  }`;
};

export function getmlContentTypeKeywordIdQuery(contentType, subCategoryIdquery, searchValue, limit) {
  return `query {
        ${contentType}Collection(where:
          {
          { ${subCategoryIdquery} }, 
          OR: [{  title_contains:"${searchValue}" }, { subTitle_contains: "${searchValue}" }] }
           ${limit})
        {
          total
          items
          {           
            sys
            {
              id
            }                    
          }
        }
      }`;
};

export function categoryQuery() {
  return `query {
        topicCategoryCollection(order: [name_ASC]
          where:{type_in:["Category", "Others"]})
        {        
         items
          {
            name
            sys{
              id
            }
          }
        }
      }`;
};

export function subCategoryForProfessionalArticleQuery(){
  return `query {
    topicCategoryCollection(order: [name_ASC] where: { subcategoryType: "Professional" }) {
      total
      items {
        name
        sys {
          id
        }
      }
    }
  }`;
}

export function subCategoryForMlArticleQuery(){
  return `query {
    topicCategoryCollection(order: [name_ASC] where: { subcategoryType: "Medicine" }) {
      total
      items {
        name
        sys {
          id
        }
      }
    }
  }`;
}

export function getSubCategoryForPILorFEA() {
  return `query {
    topicCategoryCollection(order: [name_ASC] where: { subcategoryType: "Conditions" }
    limit: 3000) {
      total
      items {
        name
        sys {
          id
        }
        childSubcategoriesCollection (limit: 1) {
          total
          items {
            name
            sys {
              id
            }
            childSubcategoriesCollection (limit: 1) {
              items {
                name
                sys {
                  id
                }
              }
            }
          }
        }
      }
    }
  }`;
}

export function subCategoryQuery(subCategoryIds) {
  return `OR: [
        {
          primaryTopic: {
            sys: {
              id_in: ${subCategoryIds} 
            }
          }
        }
        {
          secondaryTopics: {
            sys: {
              id_in: ${subCategoryIds}
            }
          }
        }
      ]`;
};

export function selectedCategoryQuery(categoryID) {
  return `query {
    topicCategoryCollection(
      where: {
        sys: { id_in: ["${categoryID}"] }
        type_in:["Category", "Others"]
      }
      limit: 1
    ) {
      items {
        childSubcategoriesCollection {
          total
          items {
            name
            sys {
              id
            }
            childSubcategoriesCollection {
              items {
                name
                sys {
                  id
                }
              }
            }
          }
        }
      }
    }
  }`;
};

export function getmlCategoryQuery(subCategoryIdquery, limit, skip, contentType_ID, searchValue) {
  return `query { 
        ${contentType_ID}Collection(
         where: {   
         AND: [
         {
           ${subCategoryIdquery}
         }, 
         { OR: [{ title_contains: "${searchValue}" }, { subTitle_contains: "${searchValue}" }] },
         ]
         }
       ${limit} ${skip}) 
       {
        total
        items
        {
          title
          slug
          sys
          {
            id
          }
          __typename            
        }
      }
     }`;
};

export function getmlCategoryIdQuery(subCategoryIdquery, limit, contentType_ID, searchValue) {
  return `query { 
        ${contentType_ID}Collection(
         where: {   
         AND: [
         {
           ${subCategoryIdquery}
         }, 
         { OR: [{ title_contains: "${searchValue}" }, { subTitle_contains: "${searchValue}" }] },
         ]
         }
       ${limit}) 
       {
        total
        items
        {        
          sys
          {
            id
          }                      
        }
      }
     }`;
};

export function getpilCategoryQuery(contentType_ID, subCategoryIdquery, limit, skip, typeOfContent, searchValue) {
  return `query { 
        ${contentType_ID}Collection(
         where: {   
         AND: [
         {
          ${subCategoryIdquery}
         },      
           {type : "${typeOfContent}"},           
           { OR: [{ title_contains: "${searchValue}" }, { subTitle_contains: "${searchValue}" }] },
         ]
         }
         ${limit} ${skip}) 
         {
            total
            items
            {
              title
              slug
              sys
              {
                id
              }
              __typename  
              type          
            }
          }
     }`
};

export function getpilCategoryIdQuery(contentType_ID, subCategoryIdquery, limit, typeOfContent, searchValue) {
  return `query { 
        ${contentType_ID}Collection(
         where: {   
         AND: [
         {
          ${subCategoryIdquery}
         },      
           {type : "${typeOfContent}"},           
           { OR: [{ title_contains: "${searchValue}" }, { subTitle_contains: "${searchValue}" }] },
         ]
         }
         ${limit}) 
         {
            total
            items
            {             
              sys
              {
                id
              }                      
            }
          }
     }`
};
